@if (selfVisible) {
    <div class="sticky bottom-0 z-[50] pointer-events-none w-full flex justify-end p-2">
        <div #container class="relative">
            <div (click)="onClick()" class="w-8 h-8 rounded shadow bg-ponder-xlight flex items-center justify-center align-middle pointer-events-auto">
                <svg class="w-6 h-6 stroke-faded-80 fill-none hover:cursor-pointer hover:stroke-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1">
                    @if (controlsVisible) {
                        <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="visibleIcon" />
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                    } @else {
                        <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="hiddenIcon" />
                    }
                </svg>
            </div>
        </div>
    </div>
}